<h1 mat-dialog-title>
    Restrict Features
    <button mat-icon-button class="close-icon" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div mat-dialog-content class="custom-dialog-content">
    <div class="table-container um-table-wrap">
    <table mat-table [dataSource]="dataSource" class="mat-table um-table">
      <ng-container matColumnDef="type">
        <th class="left-sorted-header" mat-header-cell *matHeaderCellDef> Type </th>
        <td class="left-sorted-header" mat-cell *matCellDef="let features"> {{features.uiType}} </td>
      </ng-container>
  
      <!-- Features Column -->
      <ng-container matColumnDef="features">
        <th class="left-sorted-header" mat-header-cell *matHeaderCellDef> Features </th>
        <td class="left-sorted-header" mat-cell *matCellDef="let features"> {{features.name}} </td>
      </ng-container>
    
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th class="centered-sorted-header" mat-header-cell *matHeaderCellDef> Actions </th>
        <td class="centered-sorted-header" mat-cell *matCellDef="let features">
          <input type="checkbox" name="view" [(ngModel)]="features.view" (click)="viewCheckBoxEnable(features)"> View
          <input type="checkbox" name="edit" [(ngModel)]="features.edit" [disabled]="features.disabled" (click)="editCheckBoxEnable(features)"> Edit
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>
     
  </div>
<div class="text-center">
      <button  mat-stroked-button color="basic" class="back" (click)="onClose()">Cancel</button>
      <button class="select-btn" mat-raised-button (click)="saveUser()">Save</button>
    </div>